
        require('./index.scss');
        'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cookie = require('./cookie.js');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _module = {
    $mod: $('.module-shopping-cart'),
    init: function init() {
        var items = this.$mod.find('ul[node-type="items"]');
        this.listener();
        this.clickFunc();
        _cookie2['default'].init(this.$mod, items);
    },

    clickFunc: function clickFunc() {
        var that = this;
        var temp = that.$mod.find('p[node-type="hide-cart"]');
        var items = that.$mod.find('ul[node-type="items"]');

        this.$mod.find('[node-type="hide-cart"]').on("click", function () {
            that.$mod.removeClass('show');
            Event.trigger('right-toolbar', 'shopping-cart-fold', {});
            setTimeout(function () {
                that.$mod.hide();
            }, 100);
        });

        this.$mod.find('ul[node-type="items"]').on("click", '[node-type="delete"]', function () {
            var id = $(this).parent().attr("data-id");
            that.loupanChange.call(that, 0, { id: id });
            Event.trigger('lplist-list', 'deleteCompare', {
                id: id
            });
            Event.trigger('lplist-list-new', 'deleteCompare', {
                id: id
            });
            Event.trigger('loupan-info', 'delete-compare', { id: id });
        });

        this.$mod.find('[node-type="empty"]').on("click", function () {
            items.empty();
            _cookie2['default'].clearC();
            that.$mod.find('[node-type="blank"]').show();
            that.$mod.find('[node-type="filled"]').hide();
            that.$mod.find('[node-type="compare-link"]').attr("href", "");
            Event.trigger('lplist-list', 'deleteAllCompare', {});
            Event.trigger('lplist-list-new', 'deleteAllCompare', {});
            Event.trigger('right-toolbar', 'delete-all-compare', {});
            Event.trigger('loupan-info', 'delete-all-compare', {});
        });

        $(window.document).on('click', function (e) {
            if ($(e.target).closest('.module-shopping-cart').length <= 0 && $(e.target).closest('.rt-item.compare').length <= 0 && $(e.target).closest('.box.compare').length <= 0 && $(e.target).closest('.tool-btn-pk').length <= 0 && !$(e.target).hasClass('delete')) {
                that.$mod.removeClass('show');
                Event.trigger('right-toolbar', 'shopping-cart-fold', {});
                setTimeout(function () {
                    that.$mod.hide();
                }, 100);
            }
        });
    },
    listener: function listener() {
        var that = this;
        Event.on('shopping-cart', function (command, data) {
            if (command == "addLouPan") {
                var res = that.loupanChange.call(that, 1, data);
                data && data.callback && data.callback(res);
                // Event.trigger('common-float', 'shopping-cart-unfold', {});
            } else if (command === "deleteLouPan") {
                that.loupanChange.call(that, 0, data);
            }
        });

        Event.on('shopping-cart', function (cmd) {
            switch (cmd) {
                case 'shopping-cart-fold':
                    that.$mod.show();
                    setTimeout(function () {
                        that.$mod.addClass('show');
                    }, 100);
                    break;
                case 'shopping-cart-unfold':
                    that.$mod.removeClass('show');
                    setTimeout(function () {
                        that.$mod.hide();
                    }, 100);
                    break;
                case 'change-compare-link':
                    that.changeCompareLink.call(that);
                    break;
                default:
                    break;
            }
        });
    },

    loupanChange: function loupanChange(isAdd, data) {
        var items = this.$mod.find('ul[node-type="items"]');
        if (isAdd) {
            if (items.children().length >= 4) {
                return false;
            }
            for (var i = 0; i < items.children().length; i++) {
                if (items.children().eq(i).attr('data-id') == data.id) {
                    return;
                }
            }
            _cookie2['default'].addC(data);

            items.append("<li data-id='" + data.id + "'><span class='loupan-name'>" + data.name + "</span><span class='delete' node-type='delete'>&#xe8e7;</span></li>");
            this.$mod.find('[node-type="blank"]').hide();
            this.$mod.find('[node-type="filled"]').show();
            Event.trigger('right-toolbar', 'shopping-cart-count', items.children().length);
        } else {
            items.children().each(function (index, ele) {
                if ($(ele).attr("data-id") == data.id) {
                    $(ele).remove();
                }
            });
            _cookie2['default'].remoC(data);
            if (items.children().size() == 0) {
                this.$mod.find('[node-type="blank"]').show();
                this.$mod.find('[node-type="filled"]').hide();
            } else {
                this.$mod.find('[node-type="blank"]').hide();
                this.$mod.find('[node-type="filled"]').show();
            }
            Event.trigger('right-toolbar', 'shopping-cart-count', items.children().length);
        }
        this.changeCompareLink();
        // $mod.show();
        // Event.trigger('common-float', 'shopping-cart-unfold', {});
        return true;
    },
    changeCompareLink: function changeCompareLink() {
        var href;
        var items = this.$mod.find('ul[node-type="items"]');
        var that = this;
        items.children().each(function (index, ele) {
            if (index !== 0) {
                href = href + "&";
            } else {
                href = that.$mod.find('[node-type="compare-link"]').attr("link");
            }
            href = href + $(ele).attr("data-id");
        });
        this.$mod.find('[node-type="compare-link"]').attr("href", href);
    }
};

_module.init();

exports['default'] = _module;;
    


// WEBPACK FOOTER //
// ./~/@front-end/common-module-vm/shopping-cart/index.js